import gsap from "gsap";
import { useLayoutEffect, useRef } from "react";

const Questions = () => {
    const questionsList = useRef(null);

    useLayoutEffect(() => {
        let ctx = gsap.context(() => {
			let startMarker = "85%";
			gsap.from("#titleQuestions", {
				scrollTrigger: {
					trigger: ".questions",
					start: `150 ${startMarker}`,
				},
				y: 50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#subTitleQuestions", {
				scrollTrigger: {
					trigger: ".questions",
					start: `150 ${startMarker}`,
				},
                delay: .2,
				y: 50,
				opacity: 0,
				duration: .7,
			})
            if (questionsList.current) {
                gsap.from(questionsList.current.children, {
                    scrollTrigger: {
                        trigger: ".questions",
                        start: `50% ${startMarker}`,
                    },
                    y: 50,
                    opacity: 0,
                    duration: .7,
                    stagger: (index) => 0.1 * index, // Задержка = 0.1s * индекс
                    ease: "power2.out"
                });
            }
		});
		return () => ctx.revert();
    }, []);

    return (
        <div className="questions">
            <div className="naming" id="titleQuestions">FAQ</div>
            <h2 id="subTitleQuestions">Вопросы и ответы</h2>
            <ul ref={questionsList}>
                <li>
                    <div className="title">Можно ли добавить свои параметры для расчета?</div>
                    <div className="desc">Да, в тарифе «Стандарт» доступна кастомизация.</div>
                </li>
                <li>
                    <div className="title">Как долго хранятся мои расчеты?</div>
                    <div className="desc">Все данные сохраняются в личном кабинете до тех пор пока активен тариф «Стандарт».</div>
                </li>
                <li>
                    <div className="title">Есть ли мобильная версия?</div>
                    <div className="desc">В данный момент мобильная версия не предусмотрена, мы работаем над этим ;)</div>
                </li>
            </ul>
        </div>
    );
}

export default Questions;